import { GameManager } from "./../../GameManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class Title extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = 260 * GameVars.scaleX + (GameConstants.GAME_WIDTH - 280 * GameVars.scaleX) / 2;
        this.y = 80;

        if (!this.scene.sys.game.device.os.desktop) {
            this.scaleX = GameVars.scaleX;
        }

        const title1 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "title_01");
        title1.alpha = 0;
        title1.setScale(.9);
        this.add(title1);

        const title2 = new Phaser.GameObjects.Image(this.scene, -40, 0, "texture_atlas_1", "title_02");
        title2.alpha = 0;
        this.add(title2);

        const scribble = this.scene.add.sprite(70, 45, "texture_atlas_1");
        scribble.visible = false;
        this.add(scribble);

        this.scene.anims.create({ key: "scribble_title", frames: this.scene.anims.generateFrameNames( "texture_atlas_1", { prefix: "scribble_title_", start: 1, end: 7, zeroPad: 2, suffix: ""}), frameRate: 16});

        const title4 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "title_04");
        title4.alpha = 0;
        title4.setScale(2);
        this.add(title4);

        if (GameVars.firstTimeLobby) {

            GameVars.firstTimeLobby = false;

            this.scene.tweens.add({
                targets: title1,
                alpha: 1,
                scaleX: 1,
                scaleY: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500,
                delay: 500
            });
    
            this.scene.tweens.add({
                targets: title2,
                alpha: 1,
                x: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500,
                delay: 1500
            });
    
            this.scene.time.addEvent({ delay: 2500, callback: () => {
                scribble.visible = true;
                scribble.anims.play("scribble_title");
            }, callbackScope: this});
    
            this.scene.tweens.add({
                targets: title4,
                alpha: 1,
                scaleX: 1,
                scaleY: 1,
                ease: Phaser.Math.Easing.Bounce.Out,
                duration: 500,
                delay: 3500
            });
        } else {
            title1.alpha = 1;
            title1.setScale(1);

            title2.alpha = 1;
            title2.x = 0;

            scribble.setFrame("scribble_title_07");
            scribble.visible = true;

            title4.alpha = 1;
            title4.setScale(1);
        }
    }
}
